import { FeatureStorage } from "../../_services/storage";

export function tabAccessControl(tabs) {
  if (FeatureStorage.getItems() == null) return;

  var featureItems = FeatureStorage.getItems().filter(
    (x) =>
      x.Type == "Work Centre" ||
      x.Type == "Module" ||
      x.Type == "Screen" ||
      x.Type == "Settings Screen" ||
      x.Type == "Formatted Report"
  );

  var accesibleTabs = [];

  tabs.forEach((element) => {
    if (Array.isArray(element.applicationFeatureCode)) {
      let matched = false;
      element.applicationFeatureCode.forEach((applicationFeatureCode) => {
        if (
          !matched &&
          featureItems.some(
            (x) => x.ApplicationFeatureCode == applicationFeatureCode
          )
        ) {
          accesibleTabs.push(element);
          matched = true;
        }
      });
    } else {
      if (
        featureItems.some(
          (x) => x.ApplicationFeatureCode == element.applicationFeatureCode
        )
      ) {
        accesibleTabs.push(element);
      }
    }
  });

  return accesibleTabs;
}
